define((require) => {
    "use strict";

    const {extend}     = require("underscore");
    const AddOnsView   = require("editor/ui/settings/integrations/addOns/AddOnsView");
    const CustomJsView = require("editor/ui/settings/integrations/customJs/CustomJsView");
    const SettingsView = require("ui/settings/SettingsView");
    const Storage      = require("shared/services/Storage");
    const template     = require("editor/ui/settings/integrations/IntegrationsView.tpl");

    return SettingsView.extend({

        className: SettingsView.prototype.className + " integrations-view",

        template,

        ui: {
            tabs: ".tabs-integrations > .tab",
            tabPanes: ".tab-pane"
        },

        regions: extend({
            addOnsRegion: ".add-ons",
            customActionsRegion: ".custom-actions"
        }, SettingsView.prototype.regions),

        events: {
            "click @ui.tabs": "_tabClickHandler"
        },

        viewScope: {
            experiences() {
                return this.options.experiences;
            }
        },

        onShow() {
            this.addOnsRegion.show(new AddOnsView({
                model: this.model,
                integrationsCollection: this.options.integrationsCollection,
                isManager: this.options.isManager
            }));

            const customJsView = new CustomJsView({
                experiences: this.options.experiences
            });

            this.customActionsRegion.show(customJsView);

            const activeTab = this.options.tabName || Storage.Local.get(Storage.Keys.INTEGRATIONS, "tab") || "add-ons";
            this._showTab(activeTab);
        },

        _tabClickHandler(event) {
            this._showTab(event.target.getAttribute("data-tab-name"));
        },

        _showTab(tabName) {
            const {tabs, tabPanes} = this.ui;

            tabs.each((index, tab) => {
                tab.classList.toggle("active", tab.getAttribute("data-tab-name") === tabName);
            });

            tabPanes.each((index, tabPane) => {
                tabPane.classList.toggle("active", tabPane.getAttribute("data-tab-pane") === tabName);
            });

            Storage.Local.update(Storage.Keys.INTEGRATIONS, "tab", tabName);
        },

        beforeNavigate() {
            return this.addOnsRegion.currentView.beforeNavigate();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/IntegrationsView.js